import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup3 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group3';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';



@Component({
    selector: 'partner-analysis-group3-lov',
    templateUrl: './partner-analysis-group3-lov.component.html',
    styleUrls: ['./partner-analysis-group3-lov.component.scss']
})


export class PartnerAnalysisGroup3LovComponent extends GenericLovComponent {

    code         : string; 
    name         : string; 

    partnerAnalysisGroup3s: PartnerAnalysisGroup3[] = [];

    columns = [
        {  prop: 'partnerAnalysisGroup3Code', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PartnerAnalysisGroup3LovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "partnerAnalysisGroup3";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.partnerAnalysisGroup3s = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(row : PartnerAnalysisGroup3){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
